import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { grey } from './colors';

export const border = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['border'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return {
      prominent: tokens['--semantic-border-bold'],
      emphasized: tokens['--semantic-border-emphasized'],
      subtle: tokens['--semantic-border-default'],
    };
  }

  return mode === 'light'
    ? {
        prominent: grey[300],
        emphasized: grey[150],
        subtle: grey[150],
      }
    : {
        prominent: grey[600],
        emphasized: grey[150],
        subtle: grey[850],
      };
};
